import { useTranslation } from 'react-i18next';
import './ProgressBar.css';

interface ProgressBarProps {
    step: number;
}

const ProgressBar = ({ step }: ProgressBarProps) => {
    const { t } = useTranslation();

    return (
        <div className="primotech-progress-container primotech-desktop-progress">
            <div className="primotech-progress-row">
                <div className="primotech-step-column">
                    <div className="primotech-step-circle primotech-step-circle-completed">✓</div>
                    <span className="primotech-step-label primotech-step-label-initial">{t('primotech.sessionCreated') || 'Session Created'}</span>
                </div>
                <div className="primotech-divider-container">
                    <div className="primotech-divider-first-row"></div>
                </div>
                <div className="primotech-step-column">
                    <div className={`primotech-step-circle ${step >= 2 ? 'primotech-step-circle-completed' : 'primotech-step-circle-pending'}`}>
                        {step >= 2 ? '✓' : '2'}
                    </div>
                    <span className={`primotech-step-label ${step >= 2 ? 'primotech-step-label-completed' : 'primotech-step-label-initial'}`}>{t('primotech.phoneNumber') || 'Phone Number'}</span>
                </div>
            </div>
            <div className="primotech-progress-row-start">
                <div className="primotech-empty-column"></div>
                <div className="primotech-divider-container">
                    <div className={step >= 3 ? 'primotech-divider-active' : 'primotech-divider-inactive'}></div>
                </div>
                <div className="primotech-step-column">
                    <div className={`primotech-step-circle ${step >= 3 ? 'primotech-step-circle-completed' : 'primotech-step-circle-pending'}`}>
                        {step >= 3 ? '✓' : '3'}
                    </div>
                    <span className={`primotech-step-label ${step >= 3 ? 'primotech-step-label-completed' : 'primotech-step-label-disabled'}`}>{t('primotech.otpVerification') || 'OTP Verification'}</span>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
